// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__rBqa8","title":"AfterFrontImage_title__INMa_"};